// Comparaison avec le mois précédent : chantiers qui changent de case.

import type { OpsChantier, OpsPrev } from './types.js';

/** Dernier jour du mois précédent la date d'arrêté. */
export function prevMonthEnd(asOf: string): string {
  return new Date(Date.parse(`${asOf.slice(0, 7)}-01T00:00:00Z`) - 86_400_000).toISOString().slice(0, 10);
}

export interface OpsMoves {
  /** Passés en dérive. */
  toRed: OpsChantier[];
  /** Revenus au vert. */
  toGreen: OpsChantier[];
  /** Passés en fin de chantier (facturés à 90 % et plus). */
  toFinished: OpsChantier[];
}

export function compareMonths(rows: OpsChantier[], prev: OpsPrev): OpsMoves {
  const m: OpsMoves = { toRed: [], toGreen: [], toFinished: [] };
  for (const r of rows) {
    const o = prev.by[r.code];
    if (!o) continue;
    if (r.c.e === 'r' && o.e !== 'r') m.toRed.push(r);
    if (r.c.e === 'g' && o.e !== 'g') m.toGreen.push(r);
    if (!r.c.p && o.p) m.toFinished.push(r);
  }
  return m;
}

/** Version compacte d'un jeu de données calculé au mois précédent. */
export function toPrev(rows: OpsChantier[], asOf: string): OpsPrev {
  return { asOf, by: Object.fromEntries(rows.map((r) => [r.code, { e: r.c.e, p: r.c.p }])) };
}
